import React from 'react';
import { connect } from 'react-redux';
import { Modal, Form, message, InputNumber } from 'antd';
import * as actionTypes from '../../redux/actions/seniormaster/actionTypes';
import { updateSingleBetCommission } from '../../redux/actions/seniormaster/updateSeniormaster';

const layout = {
    labelCol: { span: 10 },
    wrapperCol: { span: 24 },
};

class UpdateSingleBetCommissionModal extends React.Component {
    constructor(props) {
        super(props);
        this.form = React.createRef();
    }
    onFinish = async (values) => {
        await this.props.onUpdate({
            id:this.props.smaster?.id,
            singleBetCommissionId:this.props.smaster?.singleBetCommission?.id,
            betCommission:values.betCommission,
            highBetCommission:values.highBetCommission,
            winCommission:values.winCommission,
            highWinCommission:values.highWinCommission
        },
            this.props.token);
        if (this.props.error) {
            message.error(this.props.error);
        }
        if (this.props.message) {
            message.success(this.props.message);
        }
        this.form.current.resetFields();
        this.props.onClose();
    }
    onFinishFailed = (errors) => {
        console.log(errors)
    }
    handleCancel = () => {
        this.props.onClose();
    }
    render() {
        return (
            <Modal
                title="Update Single Bet Commission"
                key={this.props.smaster?.id}
                centered
                visible={this.props.visible}
                okButtonProps={{ form: 'update-sbc-form', key: 'submit', htmlType: 'submit' }}
                confirmLoading={this.props.loading}
                onCancel={this.handleCancel}
                okText="Save"
                loading={this.props.loading}
            >
                <Form
                {...layout}
                    ref={this.form}
                    style={{ margin: 25 }}
                    id="update-sbc-form"
                    name="basic"
                    initialValues={{
                        betCommission:this.props.smaster?.singleBetCommission?.betCommission,
                        highBetCommission:this.props.smaster?.singleBetCommission?.highBetCommission,
                        winCommission:this.props.smaster?.singleBetCommission?.winCommission,
                        highWinCommission:this.props.smaster?.singleBetCommission?.highWinCommission,
                    }}
                    onFinish={this.onFinish}
                    onFinishFailed={this.onFinishFailed}
                >
                    <Form.Item
                        name="betCommission"
                        label="Commission"
                        rules={[
                            {
                                required: true,
                                message: 'Require!',
                            }
                        ]}
                        hasFeedback
                    >
                        <InputNumber  style={{width:150}}/>
                    </Form.Item>
                    <Form.Item
                        name="highBetCommission"
                        label="High Commission"
                        rules={[
                            {
                                required: true,
                                message: 'Require!',
                            }
                        ]}
                        hasFeedback
                    >
                        <InputNumber  style={{width:150}}/>
                    </Form.Item>
                    <Form.Item
                        name="winCommission"
                        label="Tax"
                        rules={[
                            {
                                required: true,
                                message: 'Require!',
                            }
                        ]}
                        hasFeedback
                    >
                        <InputNumber  style={{width:150}}/>
                    </Form.Item>
                    <Form.Item
                        name="highWinCommission"
                        label="High Tax"
                        rules={[
                            {
                                required: true,
                                message: 'Require!',
                            }
                        ]}
                        hasFeedback
                    >
                        <InputNumber  style={{width:150}}/>
                    </Form.Item>
                </Form>
            </Modal>
        );
    }
}

const mapStateToProps = state => ({
    visible: state.seniorMaster.updateSingleBetCommissionVisible,
    loading: state.seniorMaster.loading,
    token: state.auth.token,
    error: state.seniorMaster.error,
    message: state.seniorMaster.message,
    smaster:state.seniorMaster.one
})

const mapDispatchToProps = dispatch => ({
    onUpdate: (obj, token) => dispatch(updateSingleBetCommission(obj, token)),
    onClose: () => dispatch({
        type:actionTypes.TOGGLE_SINGLE_BET_COMMISSION_UPDATE
    }),
})

export default connect(mapStateToProps, mapDispatchToProps)(UpdateSingleBetCommissionModal);